import View from 'scripts/poppet/view';
import template from 'templates/forecastView.jst.html';
/**
 * defa.views.ForecastView
 * The DEFA view for Forecasts.
 * @version 1.3.0
 */

const ForecastView = View.extend({
	
	template: template,
	tagName: 'li',
	className: 'weather-item',
	
});

export default ForecastView;
